import React, { ChangeEvent, useEffect } from 'react';
import { Components } from './styled';

const SearchBar = ({
  value,
  onChange,
  isSearching,
  clearValue,
  placeholder,
}: {
  value: string | undefined;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  isSearching: boolean;
  clearValue: () => void;
  placeholder: string;
}) => {
  return (
    <Components.Container>
      <Components.SearchBar value={value} onChange={onChange} placeholder={placeholder} />
      <Components.IconWrapper>
        {isSearching ? <Components.ClearIcon onClick={clearValue} /> : <Components.SearchIcon />}
      </Components.IconWrapper>
    </Components.Container>
  );
};

export default SearchBar;
